<template>
  <v-bottom-sheet v-model="bottomPickerFlag">
    <v-sheet class="bottom-sheet-wrap">
      <!-- 시 -->
      <v-row class="ma-0" height="283px">
        <v-col cols="6" class="pa-0">
          <p class="pl-6 mb-0 font-weight-bold">년도</p>
          <div class="time-gradation top"></div>
          <div>
            <v-container
              style="max-height: 208px"
              class="ma-0 pa-0 scroll-always"
            >
              <div class="text-left" v-scroll.self="onScroll">
                <v-list>
                  <v-list-item-group v-model="selectedTime.yearIdx">
                    <v-list-item
                      v-for="(year, i) in yearList"
                      :key="i"
                      @click="selectItem(year, 'H')"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="year" />
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
            </v-container>
          </div>
          <div class="time-gradation bottom"></div>
        </v-col>

        <!-- 분 -->
        <v-col cols="6" class="pa-0">
          <p class="pl-6 mb-0 font-weight-bold">월</p>
          <div class="time-gradation top"></div>
          <v-container
            class="ma-0 pa-0 scroll-always"
            style="max-height: 208px"
          >
            <div class="text-left" v-scroll.self="onScroll">
              <v-list>
                <v-list-item-group v-model="selectedTime.monthIdx">
                  <v-list-item
                    v-for="(month, i) in monthList"
                    :key="i"
                    @click="selectItem(month, 'M')"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="month" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-container>
          <div class="time-gradation bottom"></div>
        </v-col>
      </v-row>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
//import { getTimePickerList } from '@/utils/common/timeUtil';

export default {
  props: {
    flag: {
      type: Boolean,
    },
    /* 현재시간 */
    currTime: {
      type: Object,
      // default() {
      //   return { hour: '00', min: '00' }; // 없을 경우 기본시간 세팅
      // },
    },
  },

  data: () => ({
    bottomPickerFlag: false, // 화면플래그
    yearList: [],
    monthList: [],

    selectedTime: {},
    year: '', // 년
    month: '', // 월
    yearMonth: '', // 년월
  }),

  watch: {
    flag() {
      this.bottomPickerFlag = !this.bottomPickerFlag;
    },

    currTime() {
      this.year = this.currTime.year;
      this.month = this.currTime.month;

      // 현재 기본 세팅된(전달된) 시간이 있을 경우 선택처리
      if (this.year !== '' && this.month !== '') {
        this.yearList.forEach((data, i) => {
          if (this.year === data) this.selectedTime['yearIdx'] = i;
        });

        this.monthList.forEach((data, i) => {
          if (this.month === data) this.selectedTime['monthIdx'] = i;
        });
      }
    },

    yearMonth() {
      if (this.yearMonth.length >= 5) {
        this.$emit('changeMonth', this.yearMonth);
        this.bottomPickerFlag = false;
      }
    },
  },

  methods: {
    onScroll() {},

    /* 시간선택 */
    selectItem(val, type) {
      if (type === 'H') {
        this.year = val;
      } else {
        this.month = val;
      }

      if (this.year !== '' && this.month !== '') {
        this.yearMonth = `${this.year}-${
          this.month < 10 ? '0' + this.month : this.month
        }`;
      }
    },
  },

  created() {
    let now = new Date(); // 현재 날짜 및 시간
    let year = now.getFullYear(); // 연도

    for (let i = year; i >= year-5; i--) {
      this.yearList.push(i);
    }

    for (let i = 1; i <= 12; i++) {
      this.monthList.push(i);
    }
  },
};
</script>

<style scoped>
.picker-group {
  display: flex;
}

/* bottom-sheet */
.bottom-sheet-wrap {
  border-radius: 20px 20px 0 0;
}
.sheet-title {
  padding: 30px 24px 20px;
  font-weight: bold;
  line-height: 1.5;
  color: #363c43;
}

/* 길이 변경 */
::-webkit-scrollbar {
  width: 4px;
}

/* 트랙 (Track) */
::-webkit-scrollbar-track {
}

/* 핸들 (Handle) */
::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 3px;
}

/* bottomTimePicker.scss 참고 */
</style>
